export default "__VITE_ASSET__b09c2586__"